var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _path14, _path15, _path16, _path17, _path18, _path19, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutImageDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 354,
    viewBox: "0 0 586 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.8662 329.308H160.085V334.823H88.8662V329.308Z",
    fill: "white",
    stroke: "#262626",
    strokeWidth: 0.787818,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.038 301.892C132.038 301.892 122.9 309.928 111.083 306.304C99.2652 302.68 62.7105 290.862 62.7105 290.862L74.0551 280.778C74.0551 280.778 112.658 280.778 131.093 278.888L140.547 287.711L132.038 301.892Z",
    fill: "white",
    stroke: "#262626",
    strokeWidth: 0.787818,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0845 194.906C85.0845 194.906 75.3156 209.244 90.2841 228.94C105.253 248.635 127.312 275.421 127.312 275.421C127.312 275.421 138.341 292.753 132.038 301.734L175.684 260.295L85.0845 194.906Z",
    fill: "white",
    stroke: "#262626",
    strokeWidth: 0.787818,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M244.854 184.822L335.296 287.396C335.296 287.396 363.657 320.484 352.628 339.392C341.598 358.3 316.703 353.888 300.001 346.64C283.3 339.392 85.0847 195.064 85.0847 195.064L248.163 55.4624L325.842 113.918L244.854 184.822Z",
    fill: "white",
    stroke: "#262626",
    strokeWidth: 0.787818,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.688 147.322L163.709 126.524L112.659 171.429L145.905 197.27L198.688 147.322Z",
    fill: "#FF6B00",
    stroke: "#262626",
    strokeWidth: 0.787818,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M220.117 147.322L133.142 88.0781L80.3583 134.559L167.333 197.27L220.117 147.322Z",
    fill: "white",
    stroke: "#262626",
    strokeWidth: 0.787818,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.727 119.748L135.505 135.977L187.185 178.204L221.062 146.219L154.727 119.748Z",
    fill: "#262626"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M318.437 328.363L171.43 210.032L204.518 177.102L318.437 328.363Z",
    fill: "#262626"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M371.062 278.257L189.234 66.3344L136.293 112.816L318.436 328.363L371.062 278.257Z",
    fill: "white",
    stroke: "#262626",
    strokeWidth: 0.787818,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M248.163 117.7L362.397 24.8951C364.76 49.3174 375.16 74.0549 375.16 74.0549L486.399 178.992L448.111 212.238L450.632 214.287C468.91 232.564 450.632 254.623 450.632 254.623L348.059 344.749C360.979 326.944 345.38 301.734 345.38 301.734L244.539 184.665C214.917 148.898 248.163 117.7 248.163 117.7Z",
    fill: "white",
    stroke: "#262626",
    strokeWidth: 0.787818,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M435.034 268.488C435.034 268.488 444.487 249.423 429.204 231.303C414.078 213.183 276.21 103.992 276.21 103.992L294.802 85.557L450.948 214.444C450.948 214.444 466.231 229.57 454.887 248.478L450.948 254.78L435.034 268.488Z",
    fill: "#FF6B00",
    stroke: "#262626",
    strokeWidth: 0.787818,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M595.59 227.207C595.59 227.207 620.328 257.932 605.675 285.033C591.021 312.134 554.151 299.056 550.055 295.589C545.8 292.281 339.55 123.057 339.55 123.057C339.55 123.057 325.054 108.719 298.268 105.725C267.385 102.259 248.163 117.858 248.163 117.858L362.396 25.0527C362.396 25.0527 397.533 5.67234 440.705 32.9308C483.878 60.1893 610.244 161.188 610.244 161.188L581.095 202.784C581.095 202.784 587.555 213.971 595.59 227.207Z",
    fill: "white",
    stroke: "#262626",
    strokeWidth: 0.787818,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_34_1556",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 247,
    y: 17,
    width: 364,
    height: 285
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M595.546 226.834C595.546 226.834 620.283 257.559 605.63 284.66C590.976 311.761 554.106 298.684 550.01 295.217C545.755 291.908 339.505 122.685 339.505 122.685C339.505 122.685 325.009 108.347 298.223 105.353C267.341 101.887 248.118 117.485 248.118 117.485L362.351 24.6804C362.351 24.6804 397.488 5.30009 440.661 32.5586C483.833 59.8171 610.199 160.815 610.199 160.815L581.05 202.412C581.05 202.412 587.51 213.599 595.546 226.834Z",
    fill: "white",
    stroke: "#262626",
    strokeWidth: 0.787818,
    strokeMiterlimit: 10
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_34_1556)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_1556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.707 96.0537L412.932 99.6327L405.789 141.686L363.526 146.159L370.669 103.51L326.918 107.387L334.061 63.2464L377.812 60.2639L420.372 57.2815L427.515 14.632L468.29 12.5442L475.731 -29.807L515.017 -31L507.577 10.4565L500.434 51.6147L461.147 54.299L453.707 96.0537Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.564 137.212L439.719 178.37L398.944 183.44L405.79 141.686L446.564 137.212Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.292 92.4748L486.149 133.037L446.564 137.212L453.707 96.0538L493.292 92.4748Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.946 129.159L516.803 168.826L479.005 173.598L486.148 133.036L523.946 129.159Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 89.194L493.291 92.4748L500.434 51.6148L538.53 48.9305L575.138 46.2463L567.995 85.9133L560.554 125.282L523.946 129.159L531.09 89.194Z",
    fill: "#FF6B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.775 150.931L363.526 146.159L356.681 188.809L398.943 183.44L391.8 224.897L349.538 230.862L305.787 237.125L312.93 194.177L267.393 199.844L220.07 205.809L226.916 160.774L274.238 155.703L281.381 111.264L326.918 107.387L319.775 150.931Z",
    fill: "#FF6B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.761 115.44L240.904 69.8079L288.226 66.5272L281.381 111.264L233.761 115.44Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.702 286.933L260.548 243.687L305.787 237.125L298.941 279.775L253.702 286.933Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.718 178.37L479.005 173.598L471.862 213.564L464.719 253.231L425.432 259.494L384.955 266.055L391.8 224.897L432.575 219.23L439.718 178.37Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.566 202.827L509.66 208.195L516.803 168.826L553.411 164.054L546.566 202.827Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.269 121.405L589.126 159.879L553.411 164.054L560.554 125.282L596.269 121.405Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.227 66.5272L295.37 21.4917L341.204 19.1057L334.061 63.2465L288.227 66.5272Z",
    fill: "#262626"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M581.883 221.219L555.097 248.478L600.003 292.123C600.003 291.965 624.425 262.186 581.883 221.219Z",
    fill: "#262626"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M568.017 210.347L637.345 128.099C637.345 128.099 663.973 156.618 669.961 173.95C677.996 197.27 666.809 211.293 666.809 211.293L600.002 291.965C600.002 291.965 611.505 283.299 598.742 249.738C586.61 217.753 568.017 210.347 568.017 210.347Z",
    fill: "white",
    stroke: "#262626",
    strokeWidth: 0.787818,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M347.743 100.053C347.743 100.053 309.14 78.4667 279.991 92.1747L341.283 42.0695L388.395 51.6809L347.743 100.053Z",
    fill: "#262626"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M449.528 72.952L355.148 0.472717L292.753 55.4624L387.291 132.038L449.528 72.952Z",
    fill: "white",
    stroke: "#262626",
    strokeWidth: 0.787818,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8671 280.778L107.145 334.823H20.327L0.473961 280.778H88.8671Z",
    fill: "white",
    stroke: "#262626",
    strokeWidth: 0.787818,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M154.255 280.778C154.255 280.778 157.564 276.997 148.74 260.138C139.917 243.121 115.494 220.431 115.494 220.431C115.494 220.431 105.568 210.505 103.835 208.772L175.684 260.61L154.255 280.778Z",
    fill: "#262626"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 11.625,
    transform: "matrix(-1 0 0 1 53.2695 309)",
    fill: "white",
    stroke: "#262626",
    strokeWidth: 0.75
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_1556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 376.199,
    height: 317.933,
    fill: "white",
    transform: "matrix(1 0 0 -1 220.07 286.933)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImageDesktop);
export default __webpack_public_path__ + "static/media/aboutImageDesktop.e87e2f4ae54c6ce1b48b09b73297a348.svg";
export { ForwardRef as ReactComponent };